import {
  INSTITUTE_DETAIL_FETCHING,
  INSTITUTE_DETAIL_FAILED,
  INSTITUTE_DETAIL_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case INSTITUTE_DETAIL_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case INSTITUTE_DETAIL_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case INSTITUTE_DETAIL_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
